import React from 'react';
import Accordion from '../components/Accordion/Accordion';
import { DISCORD_URL } from '../config';
import useScrollAnimation from '../hooks/useScrollAnimation';
import styles from './FAQ.module.css';

const FAQS = [
  {
    question: 'What are the server rates?',
    answer:
      'The server runs at x1 XP, x1 SP, x1 Adena and x1 Drop rates. This provides a balanced experience that keeps progression rewarding without trivializing the classic Lineage II challenge.',
  },
  {
    question: 'Where can I download the game client?',
    answer:
      'Visit the Download page to get the official Lineage II Community client. The full client includes all required game files and the custom launcher preconfigured to connect to our server.',
  },
  {
    question: 'How do I register an account?',
    answer:
      'Go to the Account page, fill in your desired login name, email address and password, complete the captcha verification and submit. Your account will be active immediately. Your login must be 4-16 alphanumeric characters.',
  },
  {
    question: 'Can I change my class after creation?',
    answer:
      'Class transfers follow the standard Lineage II progression system. First, second and third class transfers require completing the appropriate quests or visiting the relevant NPCs in-game. No special shortcuts are available.',
  },
  {
    question: 'Are there any premium or pay-to-win features?',
    answer:
      'Our server is designed with a strictly non-pay-to-win philosophy. Any donations made to support server costs only unlock cosmetic items or quality-of-life conveniences. No stat-boosting items are available for purchase.',
  },
  {
    question: 'Does this server wipe periodically?',
    answer:
      'This server does not have scheduled wipes. Progress is permanent unless a major update requires a fresh start, in which case the community will be given ample notice and compensation will be discussed publicly.',
  },
  {
    question: 'How can I contact support?',
    answer:
      'The fastest way to get support is through our Discord server. You can also use the in-game petition system. For account-related issues, reach out to a GM through Discord with your account login and a description of the issue.',
  },
  {
    question: 'What is the donation policy?',
    answer:
      'Donations help us cover server hosting and maintenance costs. In exchange, donors receive cosmetic rewards such as titles, appearance-only gear skins and chat color options. Donations are voluntary and never required to remain competitive.',
  },
];

export default function FAQ() {
  const [ref, visible] = useScrollAnimation();

  return (
    <main className={styles.main}>
      <section className={`page-hero ${styles.hero}`} aria-label="FAQ hero">
        <h1>Frequently Asked Questions</h1>
        <p className={styles.heroSub}>Everything you need to know before you play</p>
      </section>

      <div
        ref={ref}
        className={`reveal ${visible ? 'visible' : ''} ${styles.container}`}
      >
        <div className={styles.faqList} role="list">
          {FAQS.map(({ question, answer }) => (
            <div key={question} role="listitem">
              <Accordion question={question} answer={answer} />
            </div>
          ))}
        </div>

        <div className={styles.contact}>
          <p className={styles.contactText}>
            Still have questions?{' '}
            <a
              href={DISCORD_URL}
              target="_blank"
              rel="noopener noreferrer"
              className={styles.contactLink}
            >
              Ask us on Discord
            </a>
          </p>
        </div>
      </div>
    </main>
  );
}
